import { CommonModule, DatePipe, NgIf } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { TasksAndMarketingService } from '../../../@theme/services/tasksAndMarketing.service';

@Component({
    selector: 'gd-marketing-details',
    templateUrl: './marketing-details.component.html',
    styleUrls: ['./marketing-details.component.scss'],
    imports: [
        CommonModule,
        NgIf,
        DatePipe,
    ]
})
export class MarketingDetailsComponent implements OnInit {
  @Input() marketingId: number
  public item: any

  constructor(private marketingService: TasksAndMarketingService) {}

  ngOnInit() {
    this.marketingService
      .getMarketingItem({ marketingId: this.marketingId })
      .subscribe((response) => {
        this.item = response
      })
  }
}
